var impressum = "Impressum";
var privacy = "Privacy & Legal";
var recallInfo = "Recall Info";
var signOut = "Sign Out";
var en_us = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { en_us as default, impressum, privacy, recallInfo, signOut };
